import React from "react";
import {DynamicComponent, DynamicComponentProps} from "../../core/_models";
import {drawDynamicComponent} from "../_drawDynamicComponent";
import {ButtonGroupComponent} from "./ButtonGroupComponent";
import {Col, Container, Row} from "react-bootstrap";

export function GroupComponent({config, context}: DynamicComponentProps) {
    const {children, columnSpan} = config;
    const items = (Array.isArray(children) ? children : children['items']) || [];
    const columnWidth = columnSpan || (Array.isArray(children) ? 12 : (children['align'] === 'HORIZONTAL' ? (items.length < 4 ? 12 / items.length : 3) : 12));

    const buttonGroup = (items as DynamicComponent[]).filter(e => e.type === 'BUTTON').length === items.length;

    if (buttonGroup && items.length > 0) {
        return <ButtonGroupComponent config={config} context={context}/>
    }

    return (
        <Container fluid>
            <Row>
                {(items as DynamicComponent[]).map(itemConfig => <Col xs={12} md={columnWidth} key={itemConfig.id} className="pb-6">
                    {drawDynamicComponent(itemConfig, context)}
                </Col>)}
            </Row>
        </Container>
    );
}